import { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    URLS,
    APIS,
    SF_MDFYAPP_SRCH_COND,
    SG_MDFYAPP_LST,
} from "@/tz/go/egaz/osci/lpco/app/service/OsciLpcoAprvService";

export const OSCI0201023Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0008", "auth_osci0016"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth: any = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0121" },
            { area: "comnCd", comnCd: "OSC0129" },
        ],
    });

    const location = useLocation();
    let errmsg: any;

    // Application LIST
    const [appCdNoList, setAppCdNoList] = useState([]);

    useEffect(() => {
        handler.setInit();
    }, []);

    useEffect(() => {
        handler.setInit();
    }, [location.pathname]);

    /*
     * Modify Approval Application List Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Amendment Approval Application list search conditions !== 정정 심사 신청서 목록 검색 조건 ==!
        mdfyAppSrchCond: useForm({
            defaultSchema: SF_MDFYAPP_SRCH_COND,
            defaultValues: {
                ...(pgeStore?.form || {
                    srchSbmsDtStart: comnUtils.getDate({ m: -1 }),
                    srchSbmsDtEnd: comnUtils.getDate(),
                }),
            },
        }),
    };

    /*
     * Modify Approval Application List Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Amendment Approval Application List !== 정정 심사 신청서 목록  ==!
        mdfyAppLst: useGrid({
            defaultSchema: SG_MDFYAPP_LST,
            page: 0,
            size: 10,
        }),
    };

    const fetch = {
        // Application List !== Application 목록 ==!
        getAppCdNoList: useFetch({
            api: (data) => {
                return lpcoUtils.getOrgLpcoList(auth.get("orgCd"));
            },
            onSuccess: (data) => {
                setAppCdNoList(data || []);
            },
            onError: () => {
                modal.openModal({
                    content: "msg.osc.00015",
                });
            },
        }),
        getMdfyAppList: useFetch({
            api: (page = grid.mdfyAppLst.page) => {
                // const orgInfoParam: any = srchOrgInfo;
                return APIS.getMdfyAppList(
                    { ...form.mdfyAppSrchCond.getValues(), srchOrgCd: auth.get("orgCd"), menuTp: "APRV" },
                    page,
                    grid.mdfyAppLst.size,
                );
            },
            enabled: comnUtils.isEmpty(form.mdfyAppSrchCond.errors) && form.mdfyAppSrchCond.isSubmitted,
            key: [grid.mdfyAppLst.page, grid.mdfyAppLst.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: form.mdfyAppSrchCond.getValues(),
                    srchOrgCd: auth.get("orgCd"),
                    menuTp: "APRV",
                    page: grid.mdfyAppLst.page,
                    size: data.mdfyAppList.page.totalSize,
                });
            },
            onError: (error) => {
                errmsg =
                    error.response?.data.errorCode == -1
                        ? "msg.osc.00015"
                        : error.response?.data.errorMessage || "msg.osc.00015";

                modal.openModal({
                    content: errmsg,
                });
            },
            showToast: false,
        }),
        // Change Application Assignment Confirmation Date !== 신청서 배부 확인 일시 변경 ==!
        updateReceived: useFetch({
            api: (appId, appStatCd) => {
                return APIS.updateReceived(appId, appStatCd);
            },
            onSuccess: (data, param) => {
                navigate(URLS.osci0201024s + "/" + param[0], { state: { menuTp: "APRV", appId: param[0] } });
            },
            onError: (err) => {
                modal.openModal({ content: err.response.data.errorMessage });
            },
            showToast: false,
        }),
        // Get process information to check the configuration !== 프로세스 설정 확인용 정보 조회 ==!
        checkPrcsCfgn: useFetch({
            api: (appId: string) => APIS.getAppAprvInfo({ reffId: appId }),
            onError: (error: any) => {
                console.log("checkPrcsCfgn error", error);
            },
        }),
    };

    const handler = {
        setInit: async () => {
            await fetch.getAppCdNoList.fetch();
            handler.getMdfyAppList();

            grid.mdfyAppLst.setShow("column", "btnRcve", true);
        },
        getMdfyAppList: (page: number = 0) => {
            form.mdfyAppSrchCond.handleSubmit(async () => {
                grid.mdfyAppLst.setPage(page);
                await fetch.getMdfyAppList.fetch();
            })();
        },
        // Block when the current step is missing in the process configuration !== 현재 처리단계가 프로세스 설정에 없으면 차단 ==!
        checkPrcsCfgnValid: async (appId: any): Promise<boolean> => {
            const result: any = await fetch.checkPrcsCfgn.fetch(appId);
            if (result?.prcsInfo?.content?.prcsRoleTpCd) {
                return true;
            }
            modal.openModal({ content: "msg.osc.00046" }); // Process setting error, contact the organization !== 프로세스 설정 오류, 기관 문의 ==!
            return false;
        },
        // Change Application Assignment Confirmation Date !== 신청서 배부 확인 일시 변경 ==!
        updateReceived: async (appId: any, appStatCd: any) => {
            if (!(await handler.checkPrcsCfgnValid(appId))) {
                return;
            }
            fetch.updateReceived.fetch(appId, appStatCd);
        },
    };

    const render = {
        grid_mdfyAppLst: {
            head: {},
            cell: {
                appNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    const param = {
                        menuTp: "APRV",
                        appId: rowValues.appId,
                        asnmtCfrmDtm: rowValues.asnmtCfrmDtm,
                        appStatCd: rowValues.appStatCd,
                    };
                    return (
                        <Layout direction="col" gap={1}>
                            <Link
                                to={`${URLS.osci0201024s}/${rowValues.appId}`}
                                state={param}
                            >{`${rowValues.appNo}`}</Link>
                        </Layout>
                    );
                },
                btnRcve: (props: any) => {
                    const { binding, rowValues, value } = props;
                    let bVisible = rowValues.asnmtCfrmDtm == null;
                    return (
                        bVisible && (
                            <Button
                                type="button"
                                color="success"
                                onClick={() => {
                                    handler.updateReceived(rowValues.appId, rowValues.appStatCd);
                                }}
                            >
                                {t("L_RCVE_1")}
                            </Button>
                        )
                    );
                },
            },
        },
    };

    return (
        <Page
        // id={pgeUid}
        // title={t(pgeTitle)}
        // navigation={{
        //     base: lpcoEnvs.base,
        //     nodes: [...BASE.nodes, { path: "/E", label: pgeTitle }], // !== TODO path 추가구현 필요 ==!
        // }}
        >
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.mdfyAppSrchCond.schema.srchAppNo} />
                            <Group.Control {...form.mdfyAppSrchCond.schema.srchUcrNo} />
                        </Group.Row>

                        {/* <Group.Row>
                            <Group.Control {...form.mdfyAppSrchCond.schema.srchTin} controlSize={10} />
                        </Group.Row> */}

                        <Group.Row>
                            <Group.Control {...form.mdfyAppSrchCond.schema.srchAmdTpCd} />
                            <Group.Control {...form.mdfyAppSrchCond.schema.srchAppCdNo} options={appCdNoList} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control
                                {...form.mdfyAppSrchCond.schema.srchSbmsDt}
                                rangeButton={0}
                                controlSize={10}
                            />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control
                                {...form.mdfyAppSrchCond.schema.srchAprvDt}
                                rangeButton={0}
                                controlSize={10}
                            />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.mdfyAppSrchCond.schema.srchAppStatCd} />
                            <Group.Control {...form.mdfyAppSrchCond.schema.srchCstmOfceCd} />
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={async () => {
                                    // form.mdfyAppSrchCond.reset();
                                    form.mdfyAppSrchCond.setValues({
                                        srchAppNo: null,
                                        srchUcrNo: null,
                                        srchAmdTpCd: null,
                                        srchAppCdNo: null,
                                        srchSbmsDtStart: comnUtils.getDate({ m: -1 }),
                                        srchSbmsDtEnd: comnUtils.getDate(),
                                        srchAprvDtStart: null,
                                        srchAprvDtEnd: null,
                                        srchAppStatCd: null,
                                    });
                                    handler.getMdfyAppList();
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={async () => {
                                    handler.getMdfyAppList();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.mdfyAppLst.grid}
                            data={fetch.getMdfyAppList.data?.mdfyAppList}
                            render={render.grid_mdfyAppLst}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
